module.exports = __webpack_public_path__ + "img/inactive-7.eebf673a.svg";